import * as type from '../../types';

const initialLoginState = {
    response: {},
    loading: false,
    error: null
}
const initialUserState = {
    response: {},
    loading: false,
    error: null
}

export function loginReducer(state = initialLoginState, action) {
    switch (action.type) {
        case type.FETCH_LOGIN:
            return {
                ...state,
                loading: true // Sets loading to true when login starts
            }
        case type.FETCH_LOGIN_SUCCESS:
            return {
                ...state,
                loading: false, // Sets loading to false when login succeeds
                response: action.data.data
            }
        case type.FETCH_LOGIN_FAILURE:
            return {
                ...state,
                loading: false, // Sets loading to false if login fails
                error: {
                    message: action.message,  // Store error message
                    status: action.status     // Store error status
                }
                // response: action.message
            }
        case type.FETCH_LOGIN_CLEAR:
            return {
                ...state,
                loading: false,
                response: {}
            }
        default:
            return state
    }
}

export function userReducer(state = initialUserState, action) {
    switch (action.type) {
        case type.SET_USER:
            return {
                ...state,
                loading: false,
                response: action.data
            }
        default:
            return state
    }
}